import { useMemo } from 'react';
import { CommonHeadingTxt } from '../Text/Text';
import AdvancedTable from '../AdvancedTable';

const DoctorList = ({ doctors }) => {
  // Memoize columns
  const columns = useMemo(
    () => [
      {
        name: 'Doctor Name',
        selector: 'name',
        width: '200px',
      },
      {
        name: 'Doctor Type',
        width: '200px',
        selector: 'type',
      },
    ],
    []
  );

  const fetchDoctors = useMemo(() => {
    return async ({ page, perPage, sortField, sortOrder, search, ...filters }) => {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      const data = doctors || [];
      return {
        data: data.slice(start, end),
        total: data.length,
      };
    };
  }, [doctors]);

  return (
    <div className="card mb-3 mb-xl-4 h-100">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <CommonHeadingTxt Text="Available Doctor List" />
        </div>
        <AdvancedTable
          resource="available-doctors"
          columns={columns}
          fetchData={fetchDoctors}
          enableSearch={false}
          enableFilters={false}
          enableExport={false}
          enableToolBar={false}
          enableSummary={false}
          defaultPageSize={5}
          tableId="available-doctors-table"
          scroll={{ x: 400 }}
        />
      </div>
    </div>
  );
};

export default DoctorList;
